@if (formGroup) {
  @if (formGroup.get('location_id')) {
    <div class="form-element">
      <ng-container [ngTemplateOutlet]="locationsInput" [ngTemplateOutletContext]="{ control: 'location_id' }">
      </ng-container>
    </div>
  }
}

<ng-template #locationsInput let-control="control">
  @if (locations$ | async; as options) {
    <div class="p-field-radiobutton">
      @for (option of options; track option) {
        <div class="p-field-checkbox">
          <p-radioButton
            [value]="option.id"
            [ngModel]="formGroup.get(control).value"
            (ngModelChange)="formGroup.get(control).setValue($event)"
            [inputId]="control + option.id"
            [name]="control">
          </p-radioButton>
          <label [for]="control + option.id">{{ option.name }}</label>
        </div>
      }
      @if (!options || !options.length) {
        <cap-button
          styleClass="primary btn-rounded"
          icon="fas fa-plus"
          [label]="'dental.label.create_entity' | translate: { entity: 'dental.entity.location.singular' | translate }"
          routerLink="/client/profile/location/new">
        </cap-button>
      }
    </div>
  }

  <cap-validator [control]="form.get(control)" [customName]="'order.' + control + '.label' | translateDental">
  </cap-validator>
</ng-template>
